<template>
    <ol class="list-decimal ml-6 mb-4 text-gray-900">
        <li class="mb-2 md:mb-1.5">
            本次受理案號申請內容為加密之PDF檔案，密碼為您登入時之要保人身分證字號(英文字母為大寫)。
        </li>
        <li class="mb-2 md:mb-1.5">
            若辦理保單借款時，保單尚有未清償之借款本息者，本次欲借款金額加前次借款本息合計需於保單最高可借範圍內，若給付予客戶時之前次借款本息與申請時不同，本公司將依保單最高可借範圍內調整本次欲借款金額。
        </li>
        <li class="mb-2 md:mb-1.5">
            保險單借款作業完成後，本公司會將「保險單借款通知」以E-MAIL方式傳送給您。
        </li>
        <li class="mb-2 md:mb-1.5">
            請妥善保存「保險單借款通知」，此通知效力等同批註，將成為保險契約的一部分。
        </li>
        <li class="mb-2 md:mb-1.5">
            若您欲查詢本保險單借款申請進度，請進入【<span
                class="text-link"
                @click="$emit('goPage',routeName.RECORD)"
            >申請紀錄</span>】查詢。
        </li>
        <li class="mb-2 md:mb-1.5">
            您的保險單、存摺、印章、網路交易帳號密碼應親自保管，請勿交予他人，本公司嚴禁業務同仁代保管客戶保險單、存摺、印章、網路交易帳號密碼等資料。
        </li>
    </ol>
</template>
<script>
import routeName from '@/router/constant.js';
export default {
    emits: ['goPage'],
    setup() {
        return { routeName };
    },
};
</script>
